module.exports = __webpack_public_path__ + "static/media/MrComplainJacket.f51322c6.jpg";